import {navigationItemHasVisibleSidebarChildren} from '@rdcomponents/app/routing/helpers/navigation-sidebar-menu-children';
import {
    findItemByPath,
    getFirstPagePath,
    getItemsWithWeights,
} from '@rdcomponents/navigation/favorite-routes/favorites-helper';
import {ReactNode, useMemo} from 'react';

import {useNavigationConfig} from '../../app/routing/hooks/use-app-navigation';

export type SearchableMenuItemType = {
    path: string;
    displayLabel: string;
    parentLabel?: string;
    icon?: ReactNode;
    navigatePath: string;
};

export function useSearchableMenuItems(): Array<SearchableMenuItemType> {
    const {navigationConfig} = useNavigationConfig();

    // eslint-disable-next-line sonarjs/cognitive-complexity
    return useMemo(() => {
        const itemsWithWeights = getItemsWithWeights(navigationConfig);

        return (
            itemsWithWeights
                // eslint-disable-next-line complexity
                .flatMap((entry) => {
                    const {item, path, parentPath} = entry;
                    const hasMenuChildren = navigationItemHasVisibleSidebarChildren(item);

                    if (!item.path || hasMenuChildren || !item.label) {
                        return [];
                    }

                    const parentNavigationElement = parentPath ? findItemByPath(navigationConfig, parentPath) : null;
                    const parentLabel = parentNavigationElement ? parentNavigationElement.item.label : '';
                    const displayLabel = `${parentLabel ? parentLabel + ' > ' : ''}${item.label}`;

                    const navigatePath = getFirstPagePath(item) ?? path;
                    const icon = item.icon || parentNavigationElement?.item?.icon;

                    const result: SearchableMenuItemType = {
                        path,
                        displayLabel,
                        navigatePath,
                        ...(parentLabel ? {parentLabel} : {}),
                        ...(icon ? {icon} : {}),
                    };

                    return [result];
                })
        );
    }, [navigationConfig]);
}
